import { faIdBadge, faInbox, faPlusCircle, faStore } from '@fortawesome/free-solid-svg-icons'

export const providerHomeRoute = {
  name: 'Mis servicios',
  to: '/provider',
  exact: true,
  icon: faStore
}

export const providerNewServiceRoute = {
  name: 'Publicar servicio',
  to: '/provider/services/create',
  icon: faPlusCircle
}

export const providerRequestsRoute = {
  name: 'Solicitudes',
  to: '/provider/requests',
  icon: faInbox
}

export const providerProfileRoute = {
  name: 'Perfil y verificación',
  to: '/provider/profile',
  icon: faIdBadge
}

const providerRoutes = [providerHomeRoute, providerRequestsRoute, providerNewServiceRoute, providerProfileRoute]

export default providerRoutes
